import React from 'react'
import secondOpinionright from '../../../../../assets/images/second-opinion.png'
import { useLocation, useHistory, Link } from "react-router-dom";
import { Button, Card, Col, Nav, NavItem } from 'reactstrap';
import SoComment from './SoComment';
import SoDocument from './SoDocument';
import { useState } from 'react';
import { useEffect } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import classnames from "classnames";
import { Helmet } from 'react-helmet-async';
import MyOpinionInfo from './MyOpinionInfo';
import { OpinionService } from 'utils/OpinionService';
import { FAILED_TO_FETCH_DATA } from 'utils/Constants';
import { useSelector } from 'react-redux';
import CommonLoader from 'common/CommonLoader';
import { withAlert } from 'react-alert';

export default withAlert()(function MySecondOpinionLists(props) {
    const currentUser = useSelector((state) => state.auth.currentUser);
    const [opinionsList, setOpinionsList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedStatusFilters, setSelectedStatusFilters] = useState([
        'DRAFT', 'SUBMITTED', 'REJECTED', 'ASSIGNED', 'RESPONDED', 'CLOSED'
    ]);


    useEffect(() => {
        getOpinions(selectedStatusFilters);
    }, [selectedStatusFilters])

    const handleStatusFilterChange = (status) => {
        setSelectedStatusFilters((prevFilters) => {
            if (prevFilters.includes(status)) {
                return prevFilters.filter((filter) => filter !== status);
            } else {
                return [...prevFilters, status];
            }
        });
    };

    function createQuery(filters) {
        setIsLoading(true);
        let sq = "";
        filters.map((e) => {
            if (sq === "") {
                sq = "st=='" + e + "'";
            } else {
                sq += ",st=='" + e + "'";
            }
        })
        return sq;
    }

    const getOpinions = (filters) => {
        let fsq = createQuery(filters);
        let sq = `(rb==${currentUser?.profileGuid})`;
        if (fsq !== "")
            sq += `;(${fsq})`;

        OpinionService.getOpinions(sq, 0)
            .then((response) => {
                const { status, data } = response;
                if (status === 200) {
                    // console.log(data.contents);
                    setOpinionsList(data.contents);
                    setIsLoading(false);
                } else {
                    props.alert.error(FAILED_TO_FETCH_DATA)
                    setIsLoading(false);
                }
            })
    }

    return (
        <>

            <Helmet>
                <title>Nexogic</title>
                <meta name="description" content="Nexogic provides variety of Second Opinion option for doctor and patient." />
                <link rel='canonical' href='/u/medicalcases/opinions' />
                <script type="application/ld+json">
                    {` {
                    "@context": "https://schema.org",
                    "@type": "Article",
                    "mainEntityOfPage": {
                        "@type": "WebPage",
                        "@id": "https://profile.nexogic.com/u/medicalcases/opinions"
                    },
                    "headline": "Nexogic Second Opinion for doctors and patient.",
                    "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit",
                    "image": "http://localhost:3000/static/media/second-opinion.6e1fd49a.png",  
                    "author": {
                        "@type": "Person",
                        "name": "Admin",
                        "url": "https://nexogic.com/"
                    },  
                    "publisher": {
                        "@type": "Organization",
                        "name": "Nexogic",
                        "logo": {
                        "@type": "ImageObject",
                        "url": "https://nexogic.com/wp-content/uploads/2021/07/logo.svg"
                        }
                    },
                    "datePublished": "2023-10-06",
                    "dateModified": "2023-10-06"
                    }`}
                </script>
                <script type="application/ld+json">
                    {`{
  "@context": "https://schema.org/", 
  "@type": "BreadcrumbList", 
  "itemListElement": [{
    "@type": "ListItem", 
    "position": 1, 
    "name": "Home",
    "item": "http://localhost:3000/home"  
  },{
    "@type": "ListItem", 
    "position": 2, 
    "name": "Second Opinion",
    "item": "http://localhost:3000/u/medicalcases/opinions"  
  }]
}`}
                </script>
            </Helmet>

            <div className="nexogic-second-option container-fluid">
                <div className="row">
                    <Col lg={3} md={3} sm={3}>
                        <div className="nexogic-sidebar-stiky">
                            <div className="nexogic-widget-sidebar-card card border-0 nex-second-opinion ">
                                <h3 className="card-title h2">Second Opinion</h3>
                                <div className="card-body p-0">
                                    <ul className="nexogic-lists nexogic-custom-scroll">
                                        <li>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedStatusFilters.length === 6} // All selected
                                                    onChange={() =>
                                                        setSelectedStatusFilters(
                                                            selectedStatusFilters.length === 6 ? [] : ['DRAFT', 'SUBMITTED', 'REJECTED', 'ASSIGNED', 'RESPONDED', 'CLOSED']
                                                        )
                                                    }
                                                />
                                                All
                                            </label>
                                        </li>
                                        {['DRAFT', 'SUBMITTED', 'REJECTED', 'ASSIGNED', 'RESPONDED', 'CLOSED'].map((status) => (
                                            <li key={status}>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedStatusFilters.includes(status)}
                                                        onChange={() => handleStatusFilterChange(status)}
                                                    />
                                                    {status}
                                                </label>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <Card>
                                <Link to={"/u/medicalcases/create-new-second-opinion"} className="nexogic_primary_button_outline d-block align-items-center px-2">
                                    Create Second Opinion Request
                                </Link>
                            </Card>
                        </div>
                    </Col>

                    {isLoading ?
                        <Col lg={9} md={9} sm={9} className="nexogic-second-option-left">
                            <div className="loading-spiner text-center">
                                <CommonLoader />
                            </div>
                        </Col>
                        :
                        <Col lg={9} md={9} sm={9} className="nexogic-second-option-left">
                            {(opinionsList && opinionsList.length > 0) ? opinionsList.map((e) => (
                                <MyOpinionInfo opinion={e} status={e?.status} />
                            ))
                                :
                                <div className="text-center">You have no Opinion</div>
                            }
                        </Col>
                    }
                </div>
            </div>
        </>
    )
}
)
